import React, { Component } from 'react';

import permissionVerifier from '../../commonJS/permissionVerifier';

export default class LoggedInChecker extends Component {
  // 首次判斷用route的onEnter方式處理較簡潔，此處只處理update
  shouldComponentUpdate(nextProps) {
    if (!this.props.isLogin) {
      this.props.routeHandler('/login');
      return false;
    }

    // 使用nextProps即可取得新路由
    if (!permissionVerifier(nextProps.location.pathname, this.userPermissions)) {
      this.props.routeHandler('/salesky', 'replace');
      return false;
    }

    return true;
  }

  componentWillMount() {
    const permissions = this.props.userPermission;
    // permissions 有3個地方會用到，permissionVerifier.js、這裡、SideBarGroupCt
    // 更新比對用，不該變的值可儲存
    this.userPermissions = [
      this.props.propsPackageFromSkyFamily.isAdmin,
      // 最新消息 
      permissions.salesky_news_web === '3',
      // 產品資訊
      permissions.salesky_product_web === '3' ||
      permissions.salesky_products_web === '3',
      // 服務單
      location.hostname === 'localhost' ||
      permissions.salesky_repair_web * 1 > 1 ||
      permissions.servicesky_repair_web * 1 > 1,
      // 估價單
      permissions.salesky_quotation_web === '3',
      // 成本分析表
      permissions.salesky_cost_web === '3',
      // 保證金申請單
      permissions.salesky_margin_web === '3',
      // 訂單
      permissions.salesky_order_web === '3',
      // 貨品申購書
      permissions.salesky_goods_web === '3',
      // 領貨單
      permissions.salesky_lading_web === '3',
      // 發票申請單
      permissions.salesky_invoice_web === '3',
      // 入庫單
      permissions.salesky_warehouse_web === '3',
      // 該專案用不到的權限
      permissions.salesky_calendar_web === '3',
      permissions.salesky_worklog_web === '3',
      permissions.salesky_customers_web === '3',
      permissions.salesky_sales_case_web === '3',
      permissions.servicesky_delivery_order_web === '3',
      permissions.servicesky_km_web === '3',
      permissions.servicesky_part_web === '3',
      permissions.salesky_media_cloud_web === '3' || permissions.agent_media_cloud_web === '3',
      permissions.salesky_report_web === '3' || permissions.servicesky_report_web === '3'
    ];
  }

  render() {

    const child = React.cloneElement(this.props.children, {
      routeHandler: this.props.routeHandler,
      stateHandler: this.props.stateHandler,
      isLogin: this.props.isLogin,
      userName: this.props.userName,
      language: this.props.language,
      userId: this.props.userId,
      userPhotoSrc: this.props.userPhotoSrc,
      userPermission: this.props.userPermission,
      systemEnvironment: this.props.systemEnvironment,
      logoutHandler: this.props.logoutHandler,
      propsPackageFromSkyFamily: this.props.propsPackageFromSkyFamily
    });

    return child;
  }

}



// WEBPACK FOOTER //
// ./src/skyfamily/routes/LoggedInChecker.jsx